import dev from './dev.json';
import prod from './prod.json';
import assetsRoot from './assets_root.json';

export default (() => {
    if (process.env.NODE_ENV === 'production') {
        // pull ENV out of prod configs
        const { ENV, ...other } = {
            ...prod,
            ...assetsRoot
        };

        // check if running under client
        if (typeof window !== 'undefined') {
            return other;
        }

        // merge ENV specific configs to root level
        return {
            ...other,
            ...ENV[process.env.BOOTSTRAP_ENV || 'qa-a']
        };
    }

    // default return dev configs
    return dev;
})();
